import { render } from "./modal.vue?vue&type=template&id=7d806608"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/app_project_travels/cartridge/client/default/js/plp_lp/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d806608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d806608', __exports__)) {
    api.reload('7d806608', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=7d806608", () => {
    api.rerender('7d806608', render)
  })

}


export default __exports__